import { render, staticRenderFns } from "./ReportMove.vue?vue&type=template&id=0a8cacec"
import script from "./ReportMove.vue?vue&type=script&lang=js"
export * from "./ReportMove.vue?vue&type=script&lang=js"
import style0 from "./ReportMove.vue?vue&type=style&index=0&id=0a8cacec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports